<template>
  <div>
    <home-header></home-header>
    <div class="tip">
      {{tipStr}}
    </div>
  </div>
</template>

<script>
    import HomeHeader from '@/components/home/components/header/header';
    export default {
      data(){
        return{
          tipStr: '您没有权限查看该页面',
        }
      },
      components: {
        HomeHeader
      },
      methods:{

      }
    }
</script>


<style >
  .tip {
    padding-top: 8%;
    font-size: 18px;
    font-family: Microsoft YaHei;
  }
</style>



// WEBPACK FOOTER //
// src/common/notFount.vue